import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'app-custom-modal',
  templateUrl: './custom-modal.component.html',
  styleUrls: ['./custom-modal.component.sass']
})
export class CustomModalComponent implements OnInit {

  constructor() { }
  @Input() title: string;
  ngOnInit(): void {
  }

}
